import {Model} from "vue-mc";

export class NewsCategory extends Model
{
  static CATEGORIES = {
    GENERAL: 'general',
    PRESS_STATEMENTS:'press_statements',
    ENV_PROTECTION: 'environmental_protection',
    WORKERS_RIGHTS: 'workers_rights',
    FEMINISM: 'feminism',
    MIGRATION: 'migration',
    LGBTIQ: 'lgbtiq',
    DEFENDING_PUBLIC_SPACES: 'defending_public_spaces',
    PALESTINE_SOLIDARITY: 'palestine_solidarity',
    ANTI_CAPITALISM: 'anti_capitalism',
  }

  defaults() {
    return {
      id: null,
      category: null,
    }
  }
}
